// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wMG7","newExpiryDate":"styles_newExpiryDate__1qW4v","footer":"styles_footer__MjApP"};